import React from "react";
import MetersReportView from "../../../../views/dashboard/reports/meters";

const MetersReport = () => {
  return <MetersReportView />;
};

export default MetersReport;
